// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.direction-picker_button-row_yOYJh {
  justify-content: center;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/direction-picker/direction-picker.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".button-row {\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-row": `direction-picker_button-row_yOYJh`,
	"buttonRow": `direction-picker_button-row_yOYJh`
};
export default ___CSS_LOADER_EXPORT___;
